export var valuesTranslationProjectProvider = ["Amplexor", "AzureAi", "GlobalLink", "Acolad"];
/*

*/ 
//# sourceMappingURL=TranslationProjectProvider.js.map